import { Injectable } from '@angular/core';
import { VeiculoEquipamentoTableListDTO } from 'app/model/dtos/mob/veiculo-equipamento-table-dto';
import { VeiculoEquipamentoDTO } from 'app/model/dtos/mob/veiculo-equipamento.dto';
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environment } from 'src/environments/environment';

@Injectable()
export class VeiculoEquipamentoController {

	constructor() { }

	async getEquipamento(cdEquipamento:number, cdVeiculo: number):Promise<VeiculoEquipamentoDTO>{
        let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/veiculoequipamento/:cdEquipamento/:cdVeiculo',
					environment: environment,
					pathParams: new JSONData({cdEquipamento: cdEquipamento, cdVeiculo: cdVeiculo})
				}),
			}),
			new HttpResponse(
				new VeiculoEquipamentoDTO()
			)
        );
        return await quark.call();
	}

	async getEquipamentoById(idEquipamento: string):Promise<VeiculoEquipamentoDTO>{
        let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/veiculoequipamento/:idEquipamento',
					environment: environment,
					pathParams: new JSONData({idEquipamento: idEquipamento})
				}),
			}),
			new HttpResponse(
				new VeiculoEquipamentoDTO()
			)
        );
        return await quark.call();
	}

	async transferirEquipamento(veiculoEquipamentoDTO: VeiculoEquipamentoDTO): Promise<VeiculoEquipamentoDTO> {
		let quark = new Quark(
			new HttpPut({
				url: new Url({
					id: 'mob/veiculoequipamento/transferir/:cdVeiculo',
					environment: environment,
					pathParams: new JSONData({ cdVeiculo: veiculoEquipamentoDTO.veiculo.cdVeiculo })
				}),
				data: new JSONData(veiculoEquipamentoDTO)
			}),
			new HttpResponse(
				new VeiculoEquipamentoDTO()
			)
		);
		return await quark.call();
	}

	async createEquipamento(veiculoEquipamentoDTO: VeiculoEquipamentoDTO): Promise<VeiculoEquipamentoDTO> {
		let quark = new Quark(
			new HttpPost({
				url: new Url({
					id: 'mob/veiculoequipamento',
					environment: environment
				}),
				data: new JSONData(veiculoEquipamentoDTO)
			}),
			new HttpResponse(
				new VeiculoEquipamentoDTO()
			)
		);
		return await quark.call();
	}

	async updateEquipamento(veiculoEquipamentoDTO: VeiculoEquipamentoDTO): Promise<VeiculoEquipamentoDTO> {
		let quark = new Quark(
			new HttpPut({
				url: new Url({
					id: 'mob/veiculoequipamento/:cdEquipamento',
					environment: environment,
					pathParams: new JSONData({ cdEquipamento: veiculoEquipamentoDTO.equipamento.cdEquipamento })
				}),
				data: new JSONData(veiculoEquipamentoDTO)
			}),
			new HttpResponse(
				new VeiculoEquipamentoDTO()
			)
		);
		return await quark.call();
	}

	async pagedFind(filtros?: IFilter): Promise<VeiculoEquipamentoTableListDTO>{
		let request = new Quark(
			new HttpGet({
				url: new Url({
					id:'mob/veiculoequipamento/equipamentos',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(new VeiculoEquipamentoTableListDTO)
		);
		return request.call();
	}
	
}